import taxfiling from './tax-filing/tax-filing.configuration';
import taxdeductions from './tax-deductions/tax-deductions.configuration';
import taxdependoutside from './tax-dependents-outside/tax-dependents-outside.configuration';
import jointfileroutside from './joint-filer-outside/joint-filer-outside.configuration';
import taxfileroutside from './tax-filer-outside/tax-filer-outside.configuration';

export const validations = { taxfiling, taxdeductions, taxdependoutside, jointfileroutside, taxfileroutside };
